/**
 * @module services/attention-type
 * @description Modalidad (presencial / virtual) de un slot de la lista de
 *              Atenciones (`components/appointment/ScheduleView.vue`),
 *              extraída para poder testearla sin montar el SFC.
 */

/**
 * @description Si el turno se muestra como virtual (ícono de cámara y color
 *              del chip / botón Admitir). Manda la modalidad con la que se
 *              dio el turno; el array del slot (lo que la agenda ADMITE)
 *              solo se usa si la cita no la tiene. UC-REG-272: antes un
 *              turno presencial en un horario que admite ambas se veía con
 *              la cámara.
 * @param {Object} slot - Slot con `attentionType` (array) y `appointment`
 * @returns {boolean}
 */
export function isVirtualAttention(slot) {
  const booked = slot.appointment && slot.appointment.attentionType;
  if (booked) return booked === "virtual";
  return (
    Array.isArray(slot.attentionType) && slot.attentionType.includes("virtual")
  );
}
